import { createTheme } from '@mui/material';

export const backgroundColor = 'var(--bs-body-bg)';

export const color = 'var(--bs-body-color)';

export const themeType = document.documentElement.getAttribute('data-bs-theme') || 'light';

const componentsThemeHash = {
  components: {
    MuiStack: {
      variants: [
        {
          props: { variant: 'dashboardToolbar' },
          style: {
            position: 'fixed',
            right: '20px',
            border: '1px solid lightgrey',
            background: backgroundColor,
            zIndex: '999',
            padding: '2px 5px',
            borderRadius: '4px'
          }
        }
      ]
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          zIndex: 0
        }
      }
    },
    // Name of the component
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '7px 14px',
          width: '92px',
          paddingRight: 0
        }
      }
    }
  }
};

export const themeHash = {
  typography: {
    fontFamily: 'var(--bs-body-font-family)'
  },
  palette: { mode: themeType },
  ...componentsThemeHash
};

export const theme = createTheme(themeHash);

export const menuItemStyles = {
  subMenuContent: ({ level }) => ({
    backgroundColor: level === 0 ? 'var(--bs-body-bg)' : 'transparent'
  }),
  button: {
    '&:hover': {
      backgroundColor: 'var(--bs-secondary-bg)',
      color: 'var(--bs-body-color)'
    }
  }
};

export const sideBarTheme = {
  sidebar: {
    backgroundColor: 'var(--bs-body-bg)',
    color: 'var(--bs-tertiary-background)'
  },
  menu: {
    hover: {
      backgroundColor: 'var(--bs-tertiary-background)',
      color: 'var(--bs-body-color)'
    }
  }
};

export const invertColor = hex => {
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    return '#000000';
  }
  var r = Number.parseInt(hex.slice(0, 2), 16),
    g = Number.parseInt(hex.slice(2, 4), 16),
    b = Number.parseInt(hex.slice(4, 6), 16);

  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
};
